import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: unset;
            font-style: normal;
            padding: 0px 8px 0 0;
            font-weight: ${TYPOGRAPHY.weight.base} !important;
            font-size: ${TYPOGRAPHY.size.small} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.accent")} !important;
        `,
    },
    cssOverrides: {
        formField: css`
            justify-content: end;
            align-items: center;
        `,
        inputSelect: css`
            border: 1px solid ${getColor("common.border")};
            /* border: 1px solid blue !important; */
            border-radius: 2px;
            height: 28px;
            color: ${getColor("text.main")} !important;
            > option {
                color: ${getColor("text.main")} !important;
            }
        `,
        formInputWrapper: css`
            width: 150px;
            span {
                top: -2px !important;
                padding: 0 8px !important;
            }
        `,
    },
};
